import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f46b154"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-left" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(_ctx.iconClass),
    style: _normalizeStyle(_ctx.iconStyles),
    ref: "icon",
    onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.presentTooltip && _ctx.presentTooltip(...args))),
    onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args)))
  }, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(_ctx.tooltipClass),
      ref: "tooltip",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args))),
      onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args)))
    }, [
      _hoisted_1,
      _createElementVNode("span", null, _toDisplayString(_ctx.tooltip), 1)
    ], 34), [
      [_vShow, _ctx.tooltipShown]
    ])
  ], 38))
}